module.exports = __webpack_public_path__ + "img/moguLogo.778f794e.png";